// Summer Landing Page Product Swatch Clicking
$(document).ready(function(){
  $(document).on("click",".summer_product_swatch",function(){
    //console.log($(this).data("variant-id"))
    var variant_first_image = $(this).data("first_image_url");
    var variant_second_image = $(this).data("second_image_url");
    var product_first_image = $(this).data("product-first_image");
    var product_second_image = $(this).data("product-second_image");
    var image_1 = '',image_2 = '';
    if(variant_first_image != ''  && variant_second_image != ''){
      image_1 = variant_first_image;
      image_2 = variant_second_image;
    }else{
      image_1 = product_first_image;
      image_2 = product_second_image;
    }
    $(this).parents(".collection_gridContainer-item").find(".collection_gridContainer-item-img ").find("img.first__image").attr("src",image_1);
    $(this).parents(".collection_gridContainer-item").find(".collection_gridContainer-item-img ").find("img.hover__image").attr("src",image_2);
    $(this).parents(".summer_producte__options").find(".color").removeClass("selected");
    $(this).parents(".summer_producte__options").find("#"+$(this).data("selected_id")).addClass("selected");
    $(this).parents(".collection_gridContainer-item").find(".price").text($(this).data("variant-price"));
    $(this).parents(".collection_gridContainer-item").find(".collection_gridContainer-item-img").find(".button.quick_add").attr("data-id",$(this).data("variant-id"))
    $(this).parents(".summer_producte__options").next(".button.quick_add").attr("data-id",$(this).data("variant-id"))
  });



  const url = window.location.href;
  let searchParam = window.location.search;

  if(window.location.search){
    if(searchParam.indexOf("?go-to-persona") > -1){
      $('html, body').animate({
        scrollTop: $("#persona_section").offset().top
      }, 100);
    }
  }
});




